import {
  useQuery as useTanstackQuery,
  QueryKey,
  UseQueryOptions,
  DefaultError,
} from '@tanstack/react-query'
import {
  useApiWrapperWithValidation,
  UseApiWrapperWithValidationProps,
} from '../../hooks/use-api-wrapper-with-validation'
import { BaseQueryClass } from './base-query-class'

export abstract class BaseQueryWithValidationClass<
  Args extends unknown[],
  TQueryFnData = unknown,
  TError = DefaultError,
  TData = TQueryFnData,
  TQueryKey extends QueryKey = QueryKey,
> extends BaseQueryClass<Args, TQueryFnData, TError, TData, TQueryKey> {
  public useQuery = (args?: {
    queryFnArgs?: Args
    validationOptions?: Omit<
      UseApiWrapperWithValidationProps<TQueryFnData, Args, true>,
      'requestFunction' | 'doThrowError'
    >
    options?: Omit<
      UseQueryOptions<TQueryFnData, TError, TData, TQueryKey>,
      'queryKey' | 'queryFn'
    >
  }) => {
    const { queryFnArgs, validationOptions, options } = args || {}
    const { fetcher } = useApiWrapperWithValidation<TQueryFnData, Args, true>({
      requestFunction: this.queryFn,
      doThrowError: true,
      ...validationOptions,
    })
    const nonNullArgs = queryFnArgs || ([] as unknown as Args)
    return useTanstackQuery({
      queryKey: this.getQueryKey(...nonNullArgs),
      queryFn: () => fetcher(...nonNullArgs),
      ...this.options,
      ...options,
    })
  }
}
